var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 3C10.1937 3 10.25 3.05625 10.25 3.125V4.125H14.25V3.125C14.25 3.05625 14.3063 3.00001 14.375 3H15.25C15.3188 3 15.375 3.05625 15.375 3.125V4.125H18C18.2766 4.125 18.5 4.34844 18.5 4.625V15C18.4999 15.2765 18.2765 15.5 18 15.5H6.5C6.22349 15.5 6.00008 15.2765 6 15V4.625C6 4.34844 6.22344 4.12501 6.5 4.125H9.125V3.125C9.125 3.05625 9.18126 3.00001 9.25 3H10.125ZM7.125 8.4375V14.375H17.375V8.4375H7.125ZM7.125 5.25V7.375H17.375V5.25H15.375V6C15.3749 6.06868 15.3187 6.125 15.25 6.125H14.375C14.3063 6.12499 14.2501 6.06867 14.25 6V5.25H10.25V6C10.2499 6.06868 10.1937 6.125 10.125 6.125H9.25C9.18131 6.12499 9.12509 6.06867 9.125 6V5.25H7.125Z",
    fill: "#2E3978"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/CalendarIcon.ca05530500c921b1ff85d49d5e029087.svg";
export { ForwardRef as ReactComponent };